import script from "./icon.vue?vue&type=script&lang=ts&setup=true"
export * from "./icon.vue?vue&type=script&lang=ts&setup=true"

import "./icon.vue?vue&type=style&index=0&id=6ed58a1b&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ed58a1b"]])

export default __exports__